import {isNotNil} from 'ramda';

import {
  VehicleFinancingBalloonPayment,
  VehicleFinancingDownPayment,
  VehicleFinancingTerm,
} from '@dms/api/sales';
import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

interface RateMatrixCellCoordinates {
  term: VehicleFinancingTerm;
  downPayment: VehicleFinancingDownPayment;
  balloonBracket: VehicleFinancingBalloonPayment | Nullish;
}

export function getRateMatrixCellLabel(coordinates: RateMatrixCellCoordinates) {
  return isNotNil(coordinates.balloonBracket)
    ? i18n.t('entity.vehicleFinancingTemplate.labels.editRateCellTitleBalloon', {
        term: coordinates.term,
        downPayment: coordinates.downPayment,
        balloonPayment: coordinates.balloonBracket,
      })
    : i18n.t('entity.vehicleFinancingTemplate.labels.editRateCellTitleStandard', {
        term: coordinates.term,
        downPayment: coordinates.downPayment,
      });
}
